export default "__VITE_ASSET__BlHHqYSV__"